import { apiGetOne } from './ApiBaseActions';
export const API_GET_ONE_DEMO_SOLUTION = 'API_GET_ONE_DEMO_SOLUTION';
export const API_GET_ONE_DEMO_SOLUTION_SUCCESS = 'API_GET_ONE_DEMO_SOLUTION_SUCCESS';
export const CREATE_DEMO_FAVORITE = 'CREATE_DEMO_FAVORITE';
export const DELETE_DEMO_FAVORITE = 'DELETE_DEMO_FAVORITE';
export const apiGetOneDemoSolution = (meta) => apiGetOne(API_GET_ONE_DEMO_SOLUTION, '/client/solution/demo', Object.assign({}, meta));
export const createDemoFavorite = () => ({
    type: CREATE_DEMO_FAVORITE,
});
export const deleteDemoFavorite = () => ({
    type: DELETE_DEMO_FAVORITE,
});
